"use client";
import React, {ReactElement, useContext, useEffect, useLayoutEffect, useRef, useState} from "react";
import {Typography} from "antd";
import {Button} from "@bezlimit/bezlimit-ui";
import {observer} from "mobx-react";
import {Viewer, Worker} from "@react-pdf-viewer/core";
import {defaultLayoutPlugin, ToolbarProps, ToolbarSlot} from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "./style.scss";
import _ from "lodash";
import {isMobile} from "react-device-detect";
import useResize from "../../../../../core/hooks/useResize";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import Axios, {IAxiosConfig} from "../../../../../core/Axios";
import axios from "axios";
import ErrorPassportAdd from "../../../../modal/errorPassportAdd";
import {ModalContext} from "../../../../../core/Contexts";
import Store from "../../../../../stores";
import ReservationsService from "../../../../../services/ReservationsService";

const Document = observer(({reservations}: IProps) => {
    const navigate = useNavigate();
    const contextModal = useContext(ModalContext);
    const timeout = useRef<NodeJS.Timeout>();
    const ref = useRef<HTMLDivElement>(null);
    const [loading, setLoading] = useState(false);
    const {width} = useResize();
    const params = useParams();
    const location = useLocation();

    const onClick = async () => {
        setLoading(true);
        navigate(`/signature/${params.token}/step3${location.search ?? ""}`);
    };

    const renderToolbar = (Toolbar: (props: ToolbarProps) => ReactElement) => (
        <Toolbar>
            {(slots: ToolbarSlot) => {
                const {Download, Print, Zoom} = slots;
                return (
                    <div
                        style={{
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            width: "100%"
                        }}
                    >
                        <div style={{padding: "0px 2px"}}>
                            <Zoom />
                        </div>
                        <div style={{padding: "0px 2px"}}>
                            <Download />
                        </div>
                        <div style={{padding: "0px 2px"}}>
                            <Print />
                        </div>
                    </div>
                );
            }}
        </Toolbar>
    );

    const defaultLayoutPluginInstance = defaultLayoutPlugin({renderToolbar});

    useLayoutEffect(() => {
        if (ref.current && _.lte(width ?? 0, 992) && isMobile) {
            clearTimeout(timeout.current);

            let i = 0;
            let el: HTMLDivElement | null = null;

            const loop = () => {
                do {
                    ++i;
                    el = ref.current!.querySelector(".rpv-core__inner-pages");
                } while (i == i + 1);

                if (i && !el) {
                    timeout.current = setTimeout(loop);
                } else {
                    if (el) {
                        el?.addEventListener("scroll", () => {
                            document.documentElement.scroll({
                                top: el!.scrollTop / 5,
                                left: 0
                                // behavior: 'smooth',
                            });
                        });
                    }
                }
            };

            loop();
        }
    }, [ref.current]);

    return (
        <Typography className="bl-signature-document-page">
            {!!_.get(
                _.find(_.get(reservations, "phone.docs"), (i) => _.isEqual(i?.code, "contract")),
                "link"
            ) && (
                <Typography className="container">
                    <Typography className="document">
                        <Typography ref={ref} className="pdf-container">
                            <Worker workerUrl="https://front-pdf-viewer.bezlimit.ru/pdf-worker/pdf.worker.min.js?v=1">
                                <Viewer
                                    fileUrl={_.get(
                                        _.find(_.get(reservations, "phone.docs"), (i) =>
                                            _.isEqual(i?.code, "contract")
                                        ),
                                        "link"
                                    )}
                                    plugins={[defaultLayoutPluginInstance]}
                                />
                            </Worker>
                        </Typography>
                    </Typography>
                    <Typography className="actions">
                        <Button loading={loading} type="primary" onClick={onClick}>
                            Подписать
                        </Button>
                    </Typography>
                </Typography>
            )}
        </Typography>
    );
});

export default Document;

interface IProps {
    reservations: any;
}
